@file:OptIn(InternalResourceApi::class)

package com.hyperether.goodjob.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/com.hyperether.goodjob.resources/"

public val Res.drawable.phone_24: DrawableResource by lazy {
      DrawableResource("drawable:phone_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/phone_24.xml", -1, -1),
      ))
    }

public val Res.drawable.photo_upload_area: DrawableResource by lazy {
      DrawableResource("drawable:photo_upload_area", setOf(
        ResourceItem(setOf(), "${MD}drawable/photo_upload_area.png", -1, -1),
      ))
    }

public val Res.drawable.pin_cancelled: DrawableResource by lazy {
      DrawableResource("drawable:pin_cancelled", setOf(
        ResourceItem(setOf(), "${MD}drawable/pin_cancelled.xml", -1, -1),
      ))
    }

public val Res.drawable.pin_completed: DrawableResource by lazy {
      DrawableResource("drawable:pin_completed", setOf(
        ResourceItem(setOf(), "${MD}drawable/pin_completed.xml", -1, -1),
      ))
    }

public val Res.drawable.pin_pending: DrawableResource by lazy {
      DrawableResource("drawable:pin_pending", setOf(
        ResourceItem(setOf(), "${MD}drawable/pin_pending.xml", -1, -1),
      ))
    }

public val Res.drawable.plus: DrawableResource by lazy {
      DrawableResource("drawable:plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/plus.xml", -1, -1),
      ))
    }

public val Res.drawable.premium: DrawableResource by lazy {
      DrawableResource("drawable:premium", setOf(
        ResourceItem(setOf(), "${MD}drawable/premium.xml", -1, -1),
      ))
    }

public val Res.drawable.premium_dark: DrawableResource by lazy {
      DrawableResource("drawable:premium_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/premium_dark.xml", -1, -1),
      ))
    }

public val Res.drawable.profile_pic_placeholder: DrawableResource by lazy {
      DrawableResource("drawable:profile_pic_placeholder", setOf(
        ResourceItem(setOf(), "${MD}drawable/profile_pic_placeholder.xml", -1, -1),
      ))
    }

public val Res.drawable.round_check_box: DrawableResource by lazy {
      DrawableResource("drawable:round_check_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/round_check_box.xml", -1, -1),
      ))
    }

public val Res.drawable.small_gray_map: DrawableResource by lazy {
      DrawableResource("drawable:small_gray_map", setOf(
        ResourceItem(setOf(), "${MD}drawable/small_gray_map.xml", -1, -1),
      ))
    }

public val Res.drawable.status_check_icon: DrawableResource by lazy {
      DrawableResource("drawable:status_check_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/status_check_icon.png", -1, -1),
      ))
    }

public val Res.drawable.team: DrawableResource by lazy {
      DrawableResource("drawable:team", setOf(
        ResourceItem(setOf(), "${MD}drawable/team.xml", -1, -1),
      ))
    }

public val Res.drawable.trash: DrawableResource by lazy {
      DrawableResource("drawable:trash", setOf(
        ResourceItem(setOf(), "${MD}drawable/trash.xml", -1, -1),
      ))
    }

public val Res.drawable.upload_cloud: DrawableResource by lazy {
      DrawableResource("drawable:upload_cloud", setOf(
        ResourceItem(setOf(), "${MD}drawable/upload_cloud.xml", -1, -1),
      ))
    }

public val Res.drawable.user: DrawableResource by lazy {
      DrawableResource("drawable:user", setOf(
        ResourceItem(setOf(), "${MD}drawable/user.xml", -1, -1),
      ))
    }

public val Res.drawable.user_check: DrawableResource by lazy {
      DrawableResource("drawable:user_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_check.xml", -1, -1),
      ))
    }

public val Res.drawable.user_check_job_item: DrawableResource by lazy {
      DrawableResource("drawable:user_check_job_item", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_check_job_item.xml", -1, -1),
      ))
    }

public val Res.drawable.user_check_small: DrawableResource by lazy {
      DrawableResource("drawable:user_check_small", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_check_small.xml", -1, -1),
      ))
    }

public val Res.drawable.user_check_unselect: DrawableResource by lazy {
      DrawableResource("drawable:user_check_unselect", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_check_unselect.xml", -1, -1),
      ))
    }

public val Res.drawable.user_plus: DrawableResource by lazy {
      DrawableResource("drawable:user_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_plus.xml", -1, -1),
      ))
    }

public val Res.drawable.web_left_content: DrawableResource by lazy {
      DrawableResource("drawable:web_left_content", setOf(
        ResourceItem(setOf(), "${MD}drawable/web_left_content.xml", -1, -1),
      ))
    }

public val Res.drawable.world_2_svgrepo_com_1: DrawableResource by lazy {
      DrawableResource("drawable:world_2_svgrepo_com_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/world_2_svgrepo_com_1.xml", -1, -1),
      ))
    }

public val Res.drawable.zip_icon: DrawableResource by lazy {
      DrawableResource("drawable:zip_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/zip_icon.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable1Resources(map: MutableMap<String, DrawableResource>) {
  map.put("phone_24", Res.drawable.phone_24)
  map.put("photo_upload_area", Res.drawable.photo_upload_area)
  map.put("pin_cancelled", Res.drawable.pin_cancelled)
  map.put("pin_completed", Res.drawable.pin_completed)
  map.put("pin_pending", Res.drawable.pin_pending)
  map.put("plus", Res.drawable.plus)
  map.put("premium", Res.drawable.premium)
  map.put("premium_dark", Res.drawable.premium_dark)
  map.put("profile_pic_placeholder", Res.drawable.profile_pic_placeholder)
  map.put("round_check_box", Res.drawable.round_check_box)
  map.put("small_gray_map", Res.drawable.small_gray_map)
  map.put("status_check_icon", Res.drawable.status_check_icon)
  map.put("team", Res.drawable.team)
  map.put("trash", Res.drawable.trash)
  map.put("upload_cloud", Res.drawable.upload_cloud)
  map.put("user", Res.drawable.user)
  map.put("user_check", Res.drawable.user_check)
  map.put("user_check_job_item", Res.drawable.user_check_job_item)
  map.put("user_check_small", Res.drawable.user_check_small)
  map.put("user_check_unselect", Res.drawable.user_check_unselect)
  map.put("user_plus", Res.drawable.user_plus)
  map.put("web_left_content", Res.drawable.web_left_content)
  map.put("world_2_svgrepo_com_1", Res.drawable.world_2_svgrepo_com_1)
  map.put("zip_icon", Res.drawable.zip_icon)
}
